/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDomainExpansionItem } from './CRSFDomainExpansionItem';
import {
    CRSFDomainExpansionItemFromJSON,
    CRSFDomainExpansionItemFromJSONTyped,
    CRSFDomainExpansionItemToJSON,
} from './CRSFDomainExpansionItem';

/**
 * 
 * @export
 * @interface CRSFDomainExpansionPagedResponse
 */
export interface CRSFDomainExpansionPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainExpansionPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainExpansionPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFDomainExpansionItem>}
     * @memberof CRSFDomainExpansionPagedResponse
     */
    results?: Array<CRSFDomainExpansionItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainExpansionPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFDomainExpansionPagedResponse interface.
 */
export function instanceOfCRSFDomainExpansionPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDomainExpansionPagedResponseFromJSON(json: any): CRSFDomainExpansionPagedResponse {
    return CRSFDomainExpansionPagedResponseFromJSONTyped(json, false);
}

export function CRSFDomainExpansionPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainExpansionPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFDomainExpansionItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFDomainExpansionPagedResponseToJSON(value?: CRSFDomainExpansionPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFDomainExpansionItemToJSON)),
        'total': value.total,
    };
}

